import { render } from "./TradingTips.vue?vue&type=template&id=bab466ba&scoped=true"
import script from "./TradingTips.vue?vue&type=script&lang=js"
export * from "./TradingTips.vue?vue&type=script&lang=js"

import "./TradingTips.vue?vue&type=style&index=0&id=bab466ba&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bab466ba"]])

export default __exports__